import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createBrowserHistory } from "history";
import "./partnerDetailHeader.scss";

import { UserContext } from "@src/App";
import { increment, decrement, historyLen } from "@src/@slice/historySlice";
import toast from "@src/utils/toast";
import usePartnerLike from "@src/utils/hooks/usePartnerLike";

import Icon from "@src/components/common/icons/Icon";

const PartnerDetailHeader = (props: {
  partnerName: string;
  shareLink: string;
  partnerUuid: string;
  isLike: number | null;
  isHeaderTransparent: boolean;
  partnerType: number;
  hasClose?: boolean;
}) => {
  const {
    partnerName,
    shareLink,
    partnerUuid,
    isLike,
    isHeaderTransparent,
    partnerType,
    hasClose = false,
  } = props;

  const user = useContext(UserContext);
  const history = createBrowserHistory();
  const historyLength = useSelector(historyLen);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { updatePartnerLikeFromServer, showPartnerLikeToast } = usePartnerLike();

  const [currentLike, setCurrentLike] = useState(!!isLike);

  useEffect(() => {
    switch (history.action) {
      case "PUSH":
        dispatch(increment());
        break;
      case "POP":
        if (historyLength > 0) dispatch(decrement());
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const goBack = () => {
    if (historyLength >= 1 || user.me === null) {
      navigate(-1);
    } else {
      window.location.href = "h2mwbell://webview/close";
    }
  };

  const sharePartner = () => {
    window.location.href = `h2mwbell://share?title=${partnerName}&msg=${shareLink}`;
  };

  const toggleLike = async () => {
    try {
      // 업체리스트 페이지 좋아요 상태 변경을 위함
      const likeChangedPartnerUuid = partnerUuid;
      if (!!isLike !== currentLike) {
        localStorage.removeItem("likeChangedPartnerUuid");
      } else {
        localStorage.setItem("likeChangedPartnerUuid", likeChangedPartnerUuid);
      }
      setCurrentLike(!currentLike);
      await updatePartnerLikeFromServer(partnerUuid, currentLike);
      showPartnerLikeToast(partnerType, currentLike);
    } catch (error) {
      console.error("postPartnerLike", error);
      toast.error("오류가 발생했습니다.");
    }
  };

  return (
    <header
      id="partner-detail-header-component"
      className={`
        partner-detail-header-component
        ${isHeaderTransparent === true ? "transparent" : ""}
      `}
    >
      <div className="safe-area"></div>

      <div className="inner">
        <div className="left-panel">
          <button onClick={goBack} className="btn btn-icon header-icon-button">
            <Icon
              name="Back"
              size={40}
              color={isHeaderTransparent === true ? "#ffffff" : "#191919"}
            />
          </button>
          {isHeaderTransparent === false && <h2 className="partner-name">{partnerName}</h2>}
        </div>

        <div className="right-panel">
          <button onClick={sharePartner} className="btn btn-icon header-icon-button">
            <Icon
              name="Share"
              size={40}
              color={isHeaderTransparent === true ? "#ffffff" : "#191919"}
            />
          </button>

          <button onClick={toggleLike} className="btn btn-icon header-icon-button">
            {currentLike === true ? (
              <Icon name="LikeFill" size={40} />
            ) : (
              <Icon
                name="Like"
                size={40}
                color={isHeaderTransparent === true ? "#ffffff" : "#191919"}
              />
            )}
          </button>

          {hasClose && (
            <button onClick={goBack} className="btn btn-icon header-icon-button">
              <Icon
                name="Close"
                size={40}
                color={isHeaderTransparent === true ? "#ffffff" : "#191919"}
              />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default PartnerDetailHeader;
